import axios from "@/axios.js"

function createFilterSql(mapper, key, item) {
  if (item.operator) {      

    let all_conditions = []
    item.conditions.map((condition) => {
      var cond = mapper(key, condition);
      all_conditions.push(cond + " " + item.operator)
    });

    let final_condtion = all_conditions.join(' ')
    // remove last operator
    final_condtion = final_condtion.substring(0, final_condtion.lastIndexOf(" "));
    return "(" + final_condtion + ")";

  }else{

    return mapper(key, item);

  }  

  

}

function textFilterMapper(key, item) {
  if(key == 'seniority_name'){
    key = 'csl.seniority'
  }
  if(key == 'role_name'){
    key = 'crl.role'
  }
  if(key == 'sub_role'){
    key = 'csr.sub_role'
  }

  if(key == 'address'){
    key = 'CONCAT(a.head_office_address_1,a.head_office_city,a.head_office_county)'
  }
  
  
  switch (item.type) {
    case "equals":
      return key + " = '" + item.filter + "'";
    case "notEqual":
      return key + " != '" + item.filter + "'" + " OR " + key + " IS NULL";
    case "contains":
      return key + " ILIKE '%" + item.filter + "%'";
    case "notContains":
      return key + " NOT ILIKE '%" + item.filter + "%'" + " OR " + key + " IS NULL";
    case "startsWith":
      return key + " ILIKE '" + item.filter + "%'";
    case "endsWith":
      return key + " ILIKE '%" + item.filter + "'";
    case "blank":
      return "(" + key + " is NULL or " + key + " = '')";
    case "notBlank":
        return "(" + key + " is not NULL or " + key + " != '')";
    default:
      console.log("unknown text filter type: " + item.type);
  }
}

function dateFilterMapper(key, item) {
  switch (item.type) {
    case "equals":
      return key + " = '" + item.dateFrom + "'";
    case "notEqual":
      return key + " != '" + item.dateFrom + "' OR " + key + " IS NULL";
    case "greaterThan":
      return key + " > '" + item.dateFrom + "'";
    case "greaterThanOrEqual":
      return key + " >= '" + item.dateFrom + "'";
    case "lessThan":
      return key + " < '" + item.dateFrom + "' OR " + key + " IS NULL";
    case "lessThanOrEqual":
      return key + " <= '" + item.dateFrom + "'";
    case "blank":
      return "(" + key + " is NULL or " + key + " = '')";
    case "notBlank":
        return "(" + key + " is not NULL or " + key + " != '')";
     case "inRange":
      return (
        "(" +
        key +
        " >= '" +
        item.dateFrom +
        "' and " +
        key +
        " <= '" +
        item.dateTo +
        "')"
      );
    default:
      console.log("unknown number filter type: " + item.type);
  }
}

function numberFilterMapper(key, item) {
  switch (item.type) {
    case "equals":
      return key + " = " + item.filter;
    case "notEqual":
      return key + " != " + item.filter + " OR " + key + " IS NULL";
    case "greaterThan":
      return key + " > " + item.filter;
    case "greaterThanOrEqual":
      return key + " >= " + item.filter;
    case "lessThan":
      return key + " < " + item.filter + " OR " + key + " IS NULL";
    case "lessThanOrEqual":
      return key + " <= " + item.filter;
      case "blank":
        return key + " is NULL";
      case "notBlank":
        return key + " is not NULL";
    case "inRange":
      return (
        "(" +
        key +
        " >= " +
        item.filter +
        " and " +
        key +
        " <= " +
        item.filterTo +
        ")"
      );
    default:
      console.log("unknown number filter type: " + item.type);
  }
}

export default {
  getData(request, resultsCallback) {
    const SQL = this.buildSql(request, 'contacts_for_campaign');
    axios.post("/api/contacts/contacts_for_campaign", {
        sql: SQL,
        campaignId: request.campaignId,
        campaign_account_ml_id: request.campaign_account_ml_id
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })

    // connection.query(SQL, (error, results) => {
    //   const rowCount = this.getRowCount(request, results);
    //   const resultsForPage = this.cutResultsToPageSize(request, results);
    //   resultsCallback(resultsForPage, rowCount);
    // });
  },
  getUnassociatedContacts(request, resultsCallback) {
    const SQL = this.buildSql(request , 'get_unassociated_contacts');
    console.log(SQL)
    axios.post("/api/contacts/get_unassociated_contacts", {
        sql: SQL,
        campaignId: request.campaignId,
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })

    // connection.query(SQL, (error, results) => {
    //   const rowCount = this.getRowCount(request, results);
    //   const resultsForPage = this.cutResultsToPageSize(request, results);
    //   resultsCallback(resultsForPage, rowCount);
    // });
  },
  unassociatedContactsWithAccounts(request, resultsCallback) {
    const SQL = this.buildSql(request , 'get_remaining_unmatched_contacts');

    axios.post("/api/contacts/get_remaining_unmatched_contacts", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })

    // connection.query(SQL, (error, results) => {
    //   const rowCount = this.getRowCount(request, results);
    //   const resultsForPage = this.cutResultsToPageSize(request, results);
    //   resultsCallback(resultsForPage, rowCount);
    // });
  },
  getAllDBData(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_all_db_contacts');
    console.log(SQL)
    axios.post("/api/contacts/get_all_db_contacts", {
        sql: SQL,
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })

    // connection.query(SQL, (error, results) => {
    //   const rowCount = this.getRowCount(request, results);
    //   const resultsForPage = this.cutResultsToPageSize(request, results);
    //   resultsCallback(resultsForPage, rowCount);
    // });
  },
  getEmailExistsDBData(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_emails_exists_from_db');
    // console.log(SQL)
    axios.post("/api/contacts/get_emails_exists_from_db", {
        sql: SQL,
        email: request.email
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })

    // connection.query(SQL, (error, results) => {
    //   const rowCount = this.getRowCount(request, results);
    //   const resultsForPage = this.cutResultsToPageSize(request, results);
    //   resultsCallback(resultsForPage, rowCount);
    // });
  },
  buildSql(request, method) {
    let selectSql;
    let fromSql;
    // console.log(request)
    if(method == 'get_unassociated_contacts'){
      selectSql = this.selectSql(request , method);
      fromSql = " FROM " + request.table_name
    }
    if(method == 'get_remaining_unmatched_contacts'){
      selectSql = this.selectSql(request , method);
      fromSql = " FROM " + request.table_name
    }
    // if (method == 'contacts_for_campaign') {
    //   selectSql = this.selectSql(request, method);
    //   fromSql = ` from accounts_contacts ac left join contacts c on ac.contact_id = c.uuid 
    //               inner join accounts a on a.uuid = ac.account_id 
    //               left join contact_job_title cjt on ac.uuid = cjt.accounts_contacts_id
    //               left join contact_seniority cs on ac.uuid = cs.accounts_contacts_id
    //               left join contact_seniority_list csl on csl.uuid = cs.seniority 
    //               left join contact_role cr on ac.uuid = cr.accounts_contacts_id 
    //               left join contact_role_list crl on crl.uuid = cr."role" 
    //               left join contact_sub_role csr on csr.uuid = cr.sub_role `;

    // }
    
    if (method == 'contacts_for_campaign') {
      let campaign_id = request.campaignId
      selectSql = this.selectSql(request, method);


  let contact_none_core_field_statements = ''

      const parsedobj = request.campaign_contact_none_core_field_columns.split(',');
      for (let index = 0; index < parsedobj.length; index++) {
        const field_id = parsedobj[index];
        const column_name = '_' + parsedobj[index].replaceAll('-', '_')
        contact_none_core_field_statements += 'left join (select string_agg(distinct cafv.value , \',\') as ' + column_name + ', caf.contact_id from campaign_contact_field caf inner join campaign_contact_field_values cafv on cafv.value_id = caf.uuid where caf.campaign_id = \'' + request.campaignId + '\' and caf.field_id = \'' + field_id + '\' group by caf.contact_id) con' + index + ' on con' + index + '.contact_id = c."uuid"'
      }



      
      fromSql = ` 
     from accounts_contacts ac 
    left join contacts c on ac.contact_id = c.uuid 
    left join accounts a on a.uuid = ac.account_id 
    left join contact_email ce on ac.uuid = ce.accounts_contacts_id 
    left join contact_job_title cjt on ac.uuid = cjt.accounts_contacts_id
    left join contact_mobile cm on ac.uuid = cm.accounts_contacts_id 
    left join contact_ddi cd on ac.uuid = cd.accounts_contacts_id 
    left join contact_seniority cs on ac.uuid = cs.accounts_contacts_id
    left join contact_seniority_list csl on csl.uuid = cs.seniority 
    left join contact_social_media csm on ac.uuid = csm.accounts_contacts_id
    left join contact_role cr on ac.uuid = cr.accounts_contacts_id 
    left join contact_role_list crl on crl.uuid = cr."role" 
    left join contact_sub_role csr on csr.uuid = cr.sub_role ` + contact_none_core_field_statements + `
      inner join campaign_contacts c_c on c_c.contact_id = c.uuid and c_c.campaign_id = '` + campaign_id + `'`;
    }
    
    else if (method == 'get_all_db_contacts') {
                                selectSql = this.selectSql(request, method);
                                fromSql = ` from accounts_contacts ac left join contacts c on ac.contact_id = c.uuid 
                                                          inner join accounts a on a.uuid = ac.account_id 
                                                          left join contact_job_title cjt on ac.uuid = cjt.accounts_contacts_id
                                                          left join contact_seniority cs on ac.uuid = cs.accounts_contacts_id
                                                          left join contact_seniority_list csl on csl.uuid = cs.seniority 
                                                          left join contact_role cr on ac.uuid = cr.accounts_contacts_id 
                                                          left join contact_role_list crl on crl.uuid = cr."role" 
                                                          left join contact_sub_role csr on csr.uuid = cr.sub_role `;
    } else if (method == 'get_emails_exists_from_db') {
                                  selectSql = this.selectSql(request, method);
                                  fromSql = ` from accounts_contacts ac left join contacts c on ac.contact_id = c.uuid 
                                                            inner join accounts a on a.uuid = ac.account_id 
                                                            left join contact_email ce on ac.uuid = ce.accounts_contacts_id 
                                                            left join contact_job_title cjt on ac.uuid = cjt.accounts_contacts_id
                                                            left join contact_mobile cm on ac.uuid = cm.accounts_contacts_id 
                                                            left join contact_ddi cd on ac.uuid = cd.accounts_contacts_id 
                                                            left join contact_seniority cs on ac.uuid = cs.accounts_contacts_id
                                                            left join contact_seniority_list csl on csl.uuid = cs.seniority 
                                                            left join contact_social_media csm on ac.uuid = csm.accounts_contacts_id
                                                            left join contact_role cr on ac.uuid = cr.accounts_contacts_id 
                                                            left join contact_role_list crl on crl.uuid = cr."role" 
                                                            left join contact_sub_role csr on csr.uuid = cr.sub_role `;
    } else {
      this.selectSql(request);
    }
    const whereSql = this.whereSql(request, method);
    const limitSql = this.limitSql(request);
    const orderBySql = this.orderBySql(request,method);
    const groupBySql = this.groupBySql(request);

    return selectSql + fromSql + whereSql + groupBySql + orderBySql + limitSql;
  },
  groupBySql(request) {
    var rowGroupCols = request.rowGroupCols;
    var groupKeys = request.groupKeys;

    if (this.isDoingGrouping(rowGroupCols, groupKeys)) {
      var rowGroupCol = rowGroupCols[groupKeys.length];

      return " GROUP BY " + rowGroupCol.id;
    }

    return "";
  },
  getRowCount(request, results) {
    if (results === null || results === undefined || results.length === 0) {
      return null;
    }
    const currentLastRow = request.startRow + results.length;
    return currentLastRow <= request.endRow ? currentLastRow : -1;
  },

  cutResultsToPageSize(request, results) {
    const pageSize = request.endRow - request.startRow;
    if (results && results.length > pageSize) {
      return results.splice(0, pageSize);
    } else {
      return results;
    }
  },
  selectSql(request, method) {
    var rowGroupCols = request.rowGroupCols;
    var valueCols = request.valueCols;
    var groupKeys = request.groupKeys;

    if (this.isDoingGrouping(rowGroupCols, groupKeys)) {
      var rowGroupCol = rowGroupCols[groupKeys.length];
      var colsToSelect = [rowGroupCol.id];

      valueCols.forEach(function (valueCol) {
        colsToSelect.push(
          valueCol.aggFunc + "(" + valueCol.id + ") AS " + valueCol.id
        );
      });

      return "SELECT " + colsToSelect.join(", ");
    } 
    else if(method == 'get_unassociated_contacts'){
      return "select * ";
    }
    else if(method == 'get_remaining_unmatched_contacts'){
      return "select * ";
    }
    else if (method == 'contacts_for_campaign') {
      return `SELECT distinct c.uuid as contact_id,c.title as title,a.company_name,a.uuid as account_id,CONCAT(a.head_office_address_1,' ',a.head_office_city,' ',a.head_office_county) as head_office_address,
              c.forename as forename,
              c.surname as surname,
              cjt.job_title as job_title,
              cs.seniority as seniority,
              cr."sub_role" as sub_role,
              csl.seniority as seniority_name,
              crl."role" as role_name,
              cr."role" as role, 
              csr.sub_role as sub_role,c.created_at `;
    } else if (method == 'get_all_db_contacts') {
      return `SELECT distinct c.uuid as contact_id,c.title as title,a.company_name,a.uuid as account_id,CONCAT(a.head_office_address_1,' ',a.head_office_city,' ',a.head_office_county) as head_office_address,
              c.forename as forename,
              c.surname as surname,
              cjt.job_title as job_title,
              cs.seniority as seniority,
              cr."sub_role" as sub_role,
              csl.seniority as seniority_name,
              crl."role" as role_name,
              cr."role" as role, 
              csr.sub_role as sub_role,c.created_at `;
    // } else if (method == 'get_all_db_contacts') {
    //           return `SELECT distinct c.uuid as contact_id,c.title as title,a.company_name,a.uuid as account_id,CONCAT(a.head_office_address_1,' ',a.head_office_city,' ',a.head_office_county) as head_office_address,
    //                   c.forename as forename,
    //                   c.surname as surname,
    //                   (select ce2.email from contact_email ce2 where ce2.accounts_contacts_id = ac.uuid and ce2.primary LIMIT 1) as email,
    //                   cjt.job_title as job_title,
    //                   (select cm2.mobile from contact_mobile cm2 where cm2.accounts_contacts_id = ac.uuid and cm2.primary LIMIT 1) as mobile,
    //                   (select cd2.ddi from contact_ddi cd2 where cd2.accounts_contacts_id = ac.uuid and cd2.primary LIMIT 1) as ddi,
    //                   cs.seniority as seniority,
    //                   (select csm2.social_media from contact_social_media csm2 where csm2.accounts_contacts_id = ac.uuid and csm2.primary LIMIT 1) as social_media,
    //                   cr."sub_role" as sub_role,
    //                   csl.seniority as seniority_name,
    //                   crl."role" as role_name,
    //                   cr."role" as role, 
    //                   csr.sub_role as sub_role,c.created_at `;
    }else if (method == 'get_emails_exists_from_db') {
      return `SELECT distinct c.uuid as contact_id,c.title as title,a.company_name,a.uuid as account_id,CONCAT(a.head_office_address_1,' ',a.head_office_city,' ',a.head_office_county) as head_office_address,
              c.forename as forename,
              c.surname as surname,
              ce.email as email,
              cjt.job_title as job_title,
              (select cm2.mobile from contact_mobile cm2 where cm2.accounts_contacts_id = ac.uuid and cm2.primary) as mobile,
              (select cd2.ddi from contact_ddi cd2 where cd2.accounts_contacts_id = ac.uuid and cd2.primary) as ddi,
              cs.seniority as seniority,
              (select csm2.social_media from contact_social_media csm2 where csm2.accounts_contacts_id = ac.uuid and csm2.primary) as social_media,
              cr."sub_role" as sub_role,
              csl.seniority as seniority_name,
              crl."role" as role_name,
              cr."role" as role, 
              csr.sub_role as sub_role `;
    } 
    else {
      return "SELECT *";
    }
  },
  whereSql(request, method) {
    var whereParts = [];
    var filterModel = request.filterModel;

    if (method == 'contacts_for_campaign') {
      if (request.accountId !== undefined) {
        whereParts.push(" ac.account_id = '" + request.accountId + "'")
        whereParts.push(" c.deleted = false")
      }
      
      if (filterModel) {
        // console.log(filterModel)
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          // if(item.hasOwnProperty('campaign_status')){
          //   alert("yes")
          // }
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }
    }
    else if(method == 'get_unassociated_contacts'){
      whereParts.push("account_id is null")
      if (filterModel) {
        // console.log("FilterModdel" , filterModel)
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if(method == 'get_remaining_unmatched_contacts'){
      whereParts.push("accepted is null")
      if (filterModel) {
        // console.log("FilterModdel" , filterModel)
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if (method == 'get_all_db_contacts') {
      whereParts.push(" c.deleted = false")
      if (filterModel) {
        // console.log("FilterModdel" , filterModel)
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }
    } else if (method == 'get_emails_exists_from_db') {
      whereParts.push(" ce.email = '" + request.email + "'")
      if (filterModel) {
        // console.log("FilterModdel" , filterModel)
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }
    }


    if (whereParts.length > 0) {
      return " WHERE " + whereParts.join(" AND ");
    }

    return "";
  },
  isDoingGrouping(rowGroupCols, groupKeys) {
    // we are not doing grouping if at the lowest level
    return rowGroupCols.length > groupKeys.length;
  },
  orderBySql(request,method) {
    var sortModel = request.sortModel;

    if(method == 'get_all_db_contacts'){
      if (sortModel.length === 0) return " ORDER BY c.created_at DESC ";
    }else{
      if (sortModel.length === 0) return "";
    }


    var sorts = sortModel.map(function (s) {
      return s.colId + " " + s.sort.toUpperCase();
    });

    return " ORDER BY " + sorts.join(", ") + " NULLS LAST ";
  },
  limitSql(request) {
    var blockSize = request.endRow - request.startRow;

    return " LIMIT " + (blockSize + 1) + " OFFSET " + request.startRow;
  },
  getLastRowIndex(request, results) {
    if (!results || results.length === 0) {
      return request.startRow;
    }

    var currentLastRow = request.startRow + results.length;

    return currentLastRow <= request.endRow ? currentLastRow : -1;
  }

  // helper methods ...
};
